function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M171.4 30.2V202H0C0 107 76.7 30.2 171.4 30.2Z",
  fill: "#C0EFFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M145 131H58.9a7 7 0 0 0-7 7v57a7 7 0 0 0 7 7H145a7 7 0 0 0 7-7v-57a7 7 0 0 0-7-7Z",
  fill: "#2399E2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M93 202v-31.5c0-.8-.6-1.5-1.3-1.5H66.2c-.7 0-1.2.7-1.2 1.5V202h28Z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M110 141.5V131H94v10.4a8 8 0 0 0 15.8 1v-1Z",
  fill: "#C0EFFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M146.3 88.4H60a7 7 0 0 0-7 7v28.9a7 7 0 0 0 7 6.9h86.3a7 7 0 0 0 7-7V95.4a7 7 0 0 0-7-7Z",
  fill: "#2368CC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M138.8 131.2V99.7c0-.8-.5-1.5-1.2-1.5H112c-.6 0-1.2.7-1.2 1.5v31.5h28Z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M104.7 98.8V88.4H89v10.4a8 8 0 0 0 15.8 1v-1Z",
  fill: "#2399E2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M115.6 114.7h-1.2v13.2h1.2v-13.2ZM118.9 114.7h-1.2v13.2h1.2v-13.2ZM122.2 114.7H121v13.2h1.2v-13.2ZM125.5 114.7h-1.2v13.2h1.2v-13.2ZM128.8 114.7h-1.2v13.2h1.2v-13.2ZM132.1 114.7H131v13.2h1.2v-13.2ZM135.4 114.7h-1.2v13.2h1.2v-13.2ZM69.7 185.5h-1.2v13.2h1.2v-13.2ZM73 185.5h-1.2v13.2H73v-13.2ZM76.3 185.5h-1.2v13.2h1.2v-13.2ZM79.6 185.5h-1.2v13.2h1.2v-13.2ZM83 185.5h-1.3v13.2H83v-13.2ZM86.2 185.5h-1.1v13.2h1.1v-13.2ZM89.5 185.5h-1.1v13.2h1.1v-13.2Z",
  fill: "#000"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M96.6 34.5V69H62a34.4 34.4 0 1 1 34.4-34.5v.1Z",
  fill: "#006AFF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M62 52a17.6 17.6 0 1 1 .1-35.2 17.6 17.6 0 0 1 0 35.2Zm0-33a15.4 15.4 0 1 0 .1 30.9 15.4 15.4 0 0 0 0-30.9Z",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M60 40.5a1 1 0 0 1-.8-.3l-5.7-5.6a1 1 0 1 1 1.6-1.6l4.8 5 9.2-9.3a1 1 0 1 1 1.5 1.5l-10 10a1 1 0 0 1-.7.3Z",
  fill: "#fff"
});

function SvgOnboarding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 162,
    height: 192,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.b323d0fc.svg";
export { ForwardRef as ReactComponent };